import type {
  InputHTMLAttributes,
  SelectHTMLAttributes,
  TextareaHTMLAttributes,
} from 'react';

import styles from './Input.module.css';

interface CommonProps {
  invalid?: boolean;
  mono?: boolean;
  size?: 'sm' | 'md';
}

function cx(
  base: string | undefined,
  { invalid, mono, size }: CommonProps,
  className?: string,
): string {
  return [
    base,
    invalid && styles.invalid,
    mono && styles.mono,
    size === 'sm' && styles.sm,
    className,
  ]
    .filter(Boolean)
    .join(' ');
}

export type InputProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'size'> & CommonProps;

export function Input({ invalid, mono, size, className, ...rest }: InputProps) {
  return <input className={cx(styles.input, { invalid, mono, size }, className)} {...rest} />;
}

export type SelectProps = Omit<SelectHTMLAttributes<HTMLSelectElement>, 'size'> & CommonProps;

export function Select({ invalid, mono, size, className, children, ...rest }: SelectProps) {
  return (
    <select className={cx(styles.select, { invalid, mono, size }, className)} {...rest}>
      {children}
    </select>
  );
}

export type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement> & CommonProps;

export function Textarea({ invalid, mono, size, className, ...rest }: TextareaProps) {
  return (
    <textarea className={cx(styles.textarea, { invalid, mono, size }, className)} {...rest} />
  );
}
